
import React, { useEffect, useRef } from "react";
import { Routes, Route } from "react-router-dom";

import routes from "routes.js";
import CheckPost from "views/pages/CheckPost.jsx";

let ps;

const Default = () => {
  const fullPagesRef = useRef(null);

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      //ps = new PerfectScrollbar(fullPagesRef.current);
    }

    return () => {
      if (navigator.platform.indexOf("Win") > -1) {
        //ps.destroy();
      }
    };
  }, []);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/default") {
        const Component = prop.component;
        return (
          <Route
            path={prop.path}
            element={<Component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return <Routes>{getRoutes(routes)}</Routes>;
};

export default Default;